import { appsConf } from "../appDataConf.js";
import { chunksConf } from "../chunkDataConf.js";
import { indexedDBStoreBackendSingleton } from "../IndexedDBService.js";
import { chunksMergeConf } from "../storeManagerConf/chunkCacheStoreManagerConf.js";
import { BaseStoreManager } from "./BaseStoreManager.js";

export class AppStoreManager extends BaseStoreManager {
  constructor() {
    super(indexedDBStoreBackendSingleton, appsConf.store);
  }

  async getApp(id) {
    return this.getItem(id);
  }

  async addApp(id, data) {
    return this.addItem(id, data);
  }

  async putApp(id, data) {
    return this.putItem(id, data);
  }

  async hasApp(id) {
    return this.hasItem(id);
  }

  async deleteApp(id) {
    return this.deleteItem(id);
  }
}

export class ChunksStoreManager extends BaseStoreManager {
  constructor() {
    super(indexedDBStoreBackendSingleton, chunksConf.store);
  }


  async getChunk(id) {
    return this.getItem(id);
  }

  async addChunk(id, chunk) {
    return this.addItem(id, chunk);
  }

  async putChunk(id, chunk) {
    return this.putItem(id, chunk);
  }

  async deleteChunk(id) {
    return this.deleteItem(id);
  }
}

export class MergedChunksStoreManager extends BaseStoreManager {
  constructor() {
    super(indexedDBStoreBackendSingleton, chunksMergeConf.store);
  }

  async get(id) {
    return this.getItem(id);
  }

  async add(id, chunk) {
    return this.addItem(id, chunk);
  }

  //TODO update here ok?
  async put(id, chunk) {
    return this.putItem(id, chunk);
  }

  async delete(id) {
    return this.deleteItem(id);
  }
}